import {
  Home,
  FileText,
  Banknote,
  Send,
  Building2,
  Settings,
  Crown,
  Users,
  FolderOpen,
  type LucideIcon,
} from 'lucide-react';
import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from '@/lib/utils';
import { useAuth } from '@/lib/auth';

interface RailItem {
  href: string;
  label: string;
  icon: LucideIcon;
}

const items: RailItem[] = [
  { href: '/', label: 'Início', icon: Home },
  { href: '/lancamentos', label: 'Lançamento', icon: FileText },
  { href: '/conciliacao', label: 'Conciliação', icon: Banknote },
  { href: '/usuarios', label: 'Usuários', icon: Users },
  { href: '/prestacoes', label: 'Prestações', icon: Send },
  { href: '/documentos', label: 'Documentos', icon: FolderOpen },
  { href: '/configuracoes', label: 'Configurações', icon: Settings },
];

const platformItems: RailItem[] = [
  { href: '/master', label: 'Master', icon: Crown },
  { href: '/master/workspaces', label: 'Workspaces', icon: Building2 },
];

/**
 * Rail principal esquerdo — handoff COMPONENTS §8
 * 60px width, active state: gradient ink + mint-soft icon + indicador 3px lateral
 */
export function RailLeft() {
  const { location } = useRouterState();
  const { isPlatform } = useAuth();
  const visibleItems = isPlatform ? [...items, ...platformItems] : items;

  return (
    <aside className="hidden lg:flex w-[60px] flex-col items-center gap-1.5 border-r border-frame-edge bg-frame px-2 py-4 sticky top-16 h-[calc(100dvh-4rem)] z-30">
      {visibleItems.map((item) => {
        const Icon = item.icon;
        const active =
          location.pathname === item.href ||
          (item.href !== '/' && location.pathname.startsWith(item.href));
        return (
          <Link
            key={item.href}
            to={item.href}
            aria-label={item.label}
            className={cn(
              'group relative flex h-11 w-11 items-center justify-center rounded-[14px] transition-all duration-fast',
              active
                ? 'text-mint-soft bg-[linear-gradient(160deg,var(--ink-soft),var(--ink))] shadow-[inset_0_1px_0_rgba(255,255,255,0.10),inset_0_-2px_4px_rgba(0,0,0,0.18),0_6px_14px_-6px_rgba(20,16,8,0.45)]'
                : 'text-fg-muted hover:text-fg hover:bg-card-soft',
            )}
          >
            {active && (
              <span className="absolute -left-2 top-1/2 -translate-y-1/2 h-6 w-[3px] rounded-r-full bg-mint-deep" />
            )}
            <Icon className="h-[18px] w-[18px]" strokeWidth={1.8} />
            <span className="pointer-events-none absolute left-full ml-3 whitespace-nowrap rounded-[10px] bg-ink px-2 py-1 font-mono text-[11px] text-on-ink opacity-0 shadow-clay-ink group-hover:opacity-100 transition-opacity z-[60]">
              {item.label}
            </span>
          </Link>
        );
      })}
    </aside>
  );
}
